import React, { useContext } from "react";
import TrackContext from "../../contexts/track-context";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
// import { ReactComponent as Play } from "../../assets/play.svg";
// import { ReactComponent as Pause } from "../../assets/pause.svg";
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import GetAppIcon from '@mui/icons-material/GetApp';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
// import { ReactComponent as CreateNewFolderIcon } from "../../assets/folder.svg";
// import { ReactComponent as GetAppIcon } from "../../assets/download.svg";
import { CardContent, CircularProgress, Menu, MenuItem } from "@material-ui/core";
import FavoriteIcon from "@material-ui/icons/Favorite";
import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
import { ReactComponent as Activedownload } from "../../assets/activedownload.svg";
import API from "../../services/api";
import { ReactComponent as ThumbPrint } from "../../assets/auto_fix_high_black_18dp.svg";
import CookieManager from "../../services/CookieManager";
import { useHistory } from "react-router-dom";
import Helper from "../../services/helper";
import Constants from "../../services/constants";
import SvgInline from "../../pure-components/SvgInLine";
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import WaveformWithHighlights from "../../pure-components/SvgInLine/waveformWithHighlights";

import { DownloadIcon } from "../NewUI/icons";
import SaveAltIcon from '@mui/icons-material/SaveAlt';

export default function AlternateTracks(props) {
  let trackContext = useContext(TrackContext);
  // console.log("alternate tracks  : ", props)
  // return(<></>)
  return (
    <>
      {props.alternateVersions.map((alternateVersion, i) => (
        <div 
          className="flex w-full flex-col lg:flex-row items-center px-2 my-1 rounded-xl" 
          key={alternateVersion.ID}
          style={{background: "rgb(var(--bg))", color: "rgb(var(--text))"}}
        >
          {/* Play Button + Track Info */}
          <div className="flex flex-col lg:flex-row items-start lg:items-center  w-full lg:w-1/2 lg:justify-between space-y-2 lg:space-y-0 lg:space-x-2">
            <div className="flex  w-full">
              <div className="w-2/3 flex">
                <div className="py-2 px-1 w-2/16 flex  justify-center ">
                  <button
                    aria-label="Play or Pause"
                    className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors border border-gray-400 shadow-sm flex items-center justify-center"
                    onClick={() => props.playTrack({trackId : alternateVersion.ID, 
                      title : alternateVersion.DisplayTitle || alternateVersion.Name, 
                      description : alternateVersion.Comment,
                      albumId : alternateVersion.AlbumID, 
                      album : props.albumName,
                      duration : alternateVersion.LengthSeconds,
                      bpm : alternateVersion.bpm,
                      artistName : alternateVersion.Composer,
                      isVersion : true
                    })}
                    style={{background: "rgb(var(--pink))", color: "rgb(var(--text)) !important"}}
                  >
                    {trackContext.playPause && alternateVersion.ID === trackContext.currentTrackDetail.id ? (
                      <PauseIcon 
                        style={{color: "rgb(var(--bg))", height:"36px", width:"36px"}}/>
                    ) : (
                      <PlayArrowIcon style={{color: "rgb(var(--bg))", height:"36px", width:"36px"}}/>
                    )}
                  </button>
                </div>
              
              
                <div className="w-14/16 overflow-hidden ">
                  <div className="t-title">
                    {alternateVersion?.DisplayTitle?.length > 20 
                      ? alternateVersion?.DisplayTitle.substring(0, 20) + '...' 
                      : alternateVersion?.DisplayTitle}
                  </div>
                  <div className="t-artist" style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                  }}>
                    {alternateVersion?.Composer}
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-1/3  text-center mt-1 t-desc">
                {alternateVersion?.Version}
              </div>
            </div>
          </div>

        <div className="flex flex-col lg:flex-row items-center w-full lg:w-1/2  space-y-2 lg:space-y-0 lg:space-x-2"
        style={{color: "rgb(var(--bg))"}}>
          {/* Waveform */}
          <div className="w-full lg:w-3/5 flex justify-center md:justify-start py-1">
            {alternateVersion.ID?.length > 0 && 
            // <img
            //   src={Helper.getWaveformURL(alternateVersion.ID)}
            //   alt=""
            //   className="w-full"
            //   loading="lazy"
            // />}
            // <SvgInline url={alternateVersion.waveform} width="100%" />
            <WaveformWithHighlights
              waveformDataUrl={Helper.getWaveformDataURL(alternateVersion.ID)}
              width={1000}
              height={60}
              ranges={[]}
              ID={alternateVersion.ID}
              duration={alternateVersion.LengthSeconds}
            />}
          </div>

        <div className="flex justify-around items-center lg:justify-end w-full lg:w-2/5 t-artist"
        style={{color: "rgb(var(--text))"}}>
            {/* BPM & Duration */}
            <div className="w-1/2   flex justify-around">
            <span>{Math.round(alternateVersion.Bpm)} BPM</span>
            <span>{alternateVersion.LengthSeconds && new Date(alternateVersion.LengthSeconds * 1000).toISOString().substr(14, 5)}</span>

          </div>
        {/* Action Icons */}
        <div className="w-1/2  flex justify-center items-center  space-x-4 p-2 "
        style={{color: "rgb(var(--text))"}}>
            {/* Removing for now, as harmix only processed the main tracks */}
            {/* <AutoFixHighIcon
              className="cursor-pointer hover:scale-105 transition transform w-6 h-6 lg:w-8 lg:h-8"
              onClick={() => props.magicWandSearch({ 
                id: alternateVersion.ID, 
                title: alternateVersion?.DisplayTitle || alternateVersion?.Name,
                albumId : alternateVersion.AlbumID, 
                artist : alternateVersion.Artist, 
                duration : alternateVersion.LengthSeconds
              })}
            /> */}
            {props?.favs?.includes(alternateVersion.ID) ? (
              props.favingTracks?.indexOf(alternateVersion.ID) > -1 ? 
              <div className="p-0.5" ><CircularProgress size='18px'/></div> :             
              <FavoriteIcon
                onClick={() => props.handleAddTrackToFavorites({trackId : alternateVersion.ID, 
                  title : alternateVersion.DisplayTitle || alternateVersion.Name, 
                  description : alternateVersion.Comment,
                  albumId : alternateVersion.AlbumID, 
                  album : props.albumName,
                  duration : alternateVersion.LengthSeconds,
                  bpm : alternateVersion.bpm,
                  artistName : alternateVersion.Artist})}
                className="cursor-pointer text-red-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
                style={{ fontSize: "22px"}}
              />
            ) : (
              props.favingTracks?.indexOf(alternateVersion.ID) > -1 ? 
              <div className="p-0.5" ><CircularProgress size='18px'/></div> :             
              <UnFavoriteIcon
                onClick={() => props.handleAddTrackToFavorites({trackId : alternateVersion.ID, 
                  title : alternateVersion.DisplayTitle || alternateVersion.Name, 
                  description : alternateVersion.Comment,
                  albumId : alternateVersion.AlbumID, 
                  album : props.albumName,
                  duration : alternateVersion.LengthSeconds,
                  bpm : alternateVersion.bpm,
                  artistName : alternateVersion.Artist})}
                className="cursor-pointer hover:text-red-600 hover:scale-110 transition lg:w-8"
                style={{ fontSize: "22px"}}
              />
            )}
            <CreateNewFolderOutlinedIcon
              onClick={() => props.handleProjectModal({trackId : alternateVersion.ID, albumId : alternateVersion.AlbumID, artworkRef : Helper.getArtworkURL(alternateVersion.AlbumID), audioRef : Helper.playTrackURL(alternateVersion.ID)})}
              className="cursor-pointer hover:scale-110 transition w-8 h-8 lg:w-8 lg:h-8 hover:text-blue-600"
              style={{ fontSize: "26px"}}
            />
            {props.download?.includes(alternateVersion.ID) ? (
              props.downloadingTracks?.indexOf(alternateVersion.ID) > -1 ? 
              <div className="p-0.5" ><CircularProgress size='18px'/></div> :   
              <DownloadForOfflineIcon
                onClick={() => props.downloadTrack(alternateVersion.ID)}
                className="cursor-pointer hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
                style={{ fontSize: "22px"}}
              />
            ) : (
              props.downloadingTracks?.indexOf(alternateVersion.ID) > -1 ? 
              <div className="p-0.5" ><CircularProgress size='18px'/></div> :   
              <SaveAltIcon
                style={{ fontSize: "24px"}}
                onClick={() => props.downloadTrack(alternateVersion.ID)}
                className="cursor-pointer hover:text-blue-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
              />
            )}
          </div>
        </div>
      
        </div>
        </div>
      ))}

    </>
  );
}
